import {
  ExposureData,
  ExposureProposedTrades,
  HedgeExposureData,
  HedgeNotionalData,
  HedgeProposedTrades,
  NotionalData,
} from '@/models/FundLevel/Rebalancing/ExposureCalculation';
import {
  ExpoData,
  PropsedExposureTrades,
} from '@/models/FundLevel/Rebalancing/ExposureCalculation/ProposedTrades';

import { createAction, createAsyncAction } from 'typesafe-actions';

import { SendProposedTradesPayload } from '../types';

export type GetExposureCalculationDataRequestPayload = {
  report_date_flag: boolean;
  valuation_date_flag: boolean;
  fund_ids?: number[];
  // formally customer
  fund_company_id: number;
  company_entity_ids?: string[];
  exposure_start_date: string;
  exposure_end_date: string;
  deal_name_mode: boolean;
};
export type GetHedgeNotionalRequestPayload = {
  fund_ids?: number[];
  // formally customer
  fund_company_id: number;
  company_entity_ids?: string[];
  hedge_start_date: string;
  hedge_end_date: string;
};

export type GetExposureCalculationDataSuccessPayload = {
  data: ExposureData[];
};

export const getHedgeExposureData = createAsyncAction(
  'exposure/getHedgeExposureData/request',
  'exposure/getHedgeExposureData/success',
  'exposure/getHedgeExposureData/failure',
)<
  GetExposureCalculationDataRequestPayload,
  GetExposureCalculationDataSuccessPayload,
  undefined
>();

export type GetHedgeNotionalDataSuccessPayload = {
  data: HedgeNotionalData;
};

export const getHedgeNotionalData = createAsyncAction(
  'exposure/getHedgeNotionalData/request',
  'exposure/getHedgeNotionalData/success',
  'exposure/getHedgeNotionalData/failure',
)<
  GetHedgeNotionalRequestPayload,
  GetHedgeNotionalDataSuccessPayload,
  undefined
>();

export type GetProposedTradesRequestPayload = {
  expo_data: ExposureProposedTrades[];
  hedge_data: HedgeProposedTrades[];
  deal_name_mode: boolean;
};

export type GetProposedTradesSuccessPayload = {
  data: PropsedExposureTrades;
};

export const getProposedTrades = createAsyncAction(
  'exposure/getProposedTrades/request',
  'exposure/getProposedTrades/success',
  'exposure/getProposedTrades/failure',
)<
  GetProposedTradesRequestPayload,
  GetProposedTradesSuccessPayload,
  undefined
>();

export const resetExposureAndHedges = createAction('exposure/reset')();

export type SendProposedTradesRequestPayload = {
  trade_requests_data: SendProposedTradesPayload[];
};

export const sendTrades = createAsyncAction(
  'exposure/sendProposedTrades/request',
  'exposure/sendProposedTrades/success',
  'exposure/sendProposedTrades/failure',
)<SendProposedTradesRequestPayload, undefined, undefined>();

export type AddCloseOutTradesToProposedPayload = {
  trades: ExpoData[];
};

export const addCloseOutTradesToProposed = createAction(
  'exposure/addCloseOutTradesToProposed',
)<AddCloseOutTradesToProposedPayload>();

export type GenerateCloseoutTradesFromHedgesRequestPayload = {
  selected_hedges: NotionalData[];
};

export type HedgeCloseoutTradeData = Omit<NotionalData, 'transaction_id'> & {
  customer_id: number;
  bk_entity_id: string;
};

export type GenerateCloseoutTradesFromHedgesSuccessPayload = {
  closeout_trades: HedgeCloseoutTradeData[];
};

export const clearHedgeCloseoutTrades = createAction(
  'exposure/clearHedgeCloseoutTrades',
)();

export const clearCloseoutExposureLedgerIds = createAction(
  'exposure/clearCloseoutExposureLedgerIds',
)();

export const clearCloseoutHedgeIds = createAction(
  'exposure/clearCloseoutHedgeIds',
)();

export const generateCloseoutTradesFromHedges = createAsyncAction(
  'exposure/generateCloseoutTradesFromHedges/request',
  'exposure/generateCloseoutTradesFromHedges/success',
  'exposure/generateCloseoutTradesFromHedges/failure',
)<
  GenerateCloseoutTradesFromHedgesRequestPayload,
  GenerateCloseoutTradesFromHedgesSuccessPayload,
  undefined
>();
